import React from "react";
import "./textcarosul.css";

function TextCarosul() {
  const items = [
    <>
      <img src="/images/leftwing.png" className="wings" alt="leftwing" />
      <span>
        BeFiSc wins the{" "}
        <span style={{ color: "#B6FF00" }}>Fintech Innovation of the Year</span>{" "}
        Award 🎉
      </span>
      <img src="/images/bwimage.png" alt="bwimage" className="bussiness-world" />
      <img src="/images/rightwing.png" className="wings" alt="rightwing" />
    </>,
    <>
      <img src="/images/leftwing.png" className="wings" alt="leftwing" />
      <span>
        BeFiSc wins the{" "}
        <span style={{ color: "#B6FF00" }}>Fintech Innovation of the Year</span>{" "}
        Award 🎉
      </span>
      <img src="/images/bwimage.png" alt="bwimage" className="bussiness-world" />
      <img src="/images/rightwing.png" className="wings" alt="rightwing" />
    </>,
  ];

  // Duplicate items for seamless scroll
  const allItems = [...items, ...items];

  return (
    <div className="stock-ticker">
      <div className="stock-ul">
        {allItems.map((content, index) => (
          <div className="stock-li" key={index}>
            {content}
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(TextCarosul);
